export default {
    title: "",
    unavailable: "This product is no longer available."
}